import $ from 'jquery';
// import LazyLoad from "vanilla-lazyload";
import slick from 'slick-carousel';

$( () => {
  var $slickElement = $('[data-slick]');

  // nav slider left
  $('.slick-prev').on( 'click' ,function(e) {
    e.preventDefault();
    $slickElement.slick('slickPrev');
  });

  // nav slider right
  $('.slick-next').on( 'click' ,function(e) {
    e.preventDefault();
    $slickElement.slick('slickNext');
  });

  // init slick
  $slickElement.slick({
    arrows: false,
    swipeToSlide: true,
    rows: 0
  });

  // helpers
  function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  if( $( '.gallery-filter-container' ).length ) {
    // var myLazyLoad = new LazyLoad();

    $('.gallery-filter').slick('slickFilter', '.kitchen');
    $('.gallery-filter').slick('refresh');

    $( '.gallery-filter-buttons button' ).on( 'click', function() {
      let filterClass = $( this ).data( 'filter' );
      $( '.gallery-filter-buttons button' ).removeClass( 'active' )
      $( this ).addClass( 'active' )
      $('.gallery-filter').slick('slickUnfilter');
      $('.gallery-filter').slick('slickFilter', filterClass);
      $('.gallery-filter').slick('refresh');
      // modalImageClick();

      // myLazyLoad.update();
    } )

    $( '.home-model-label' ).on( 'click', function() {
      let filterModel = $( this ).data( 'model' )

      if( filterModel == 'all' ) {
        $('.gallery-filter').slick('slickUnfilter');
        $('.gallery-filter').slick('slickFilter', '.kitchen');
        $( '.gallery-filter-buttons button' ).removeClass( 'active' )
        $( '.gallery-filter-buttons button.first-button' ).addClass( 'active' )
        $( '.gallery-filter-buttons button' ).attr( 'disabled', false );
        $( '.gallery-filter-buttons button' ).removeClass( 'disabled' );
      } else {
        $('.gallery-filter').slick('slickUnfilter');
        $('.gallery-filter').slick('slickFilter', filterModel);
        $( '.gallery-filter-buttons button' ).attr( 'disabled', true );
        $( '.gallery-filter-buttons button' ).addClass( 'disabled' );
      }
      $('.gallery-filter').slick('refresh');
      // myLazyLoad.update();
    } )

  }

  if( $( '.normal-gallery' ).length && $( '.process-filter-option' ).length ) {
    // var myLazyLoad = new LazyLoad();
    
    $( '.normal-carousel' ).slick('slickFilter', '.calgary');

    $( '.process-filter-button' ).on( 'click', function() {
      let filterClass = '.' + $( this ).data( 'filter' );
      $('.normal-carousel').slick('slickUnfilter');
      $('.normal-carousel').slick('slickFilter', filterClass);
      // myLazyLoad.update();
    } )
  }

} )